

export const baseURL= 
  "https://admin.houseofdhanushdhari.com/api/" 
 


export const auth={
   login: baseURL+"gym/login",
   register:baseURL+'gym-register',
   getProfile:baseURL+'gym/profile',
   logoutUser:baseURL+'real-estate/logout',
  paymentHistory:baseURL+'gym/payment-history'
}


export const property={
   getPackages:baseURL+'burnout-gym-package',
   getProperty:baseURL+'real-estate-property',
   getGallery:baseURL+'real-estate/gallery',
   orderPackage:baseURL+'gym/create-order',
   verifyPayment:baseURL+'gym/verify-payment'
}

